import { render } from "./law-mes.vue?vue&type=template&id=6500c7df&scoped=true"
import script from "./law-mes.vue?vue&type=script&lang=js"
export * from "./law-mes.vue?vue&type=script&lang=js"

import "./law-mes.vue?vue&type=style&index=0&id=6500c7df&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6500c7df"]])

export default __exports__